
import { withStyles } from "@mui/styles";
import { Tooltip } from "@mui/material";

export const ToolTip = withStyles({
    tooltip: {
        color: "#000",
        backgroundColor: "#FFFFFF",
        padding: '8px 14px 8px 14px',
        boxShadow: '0 1rem 3rem rgba(0, 0, 0, .175) !important',
        borderRadius: '12px !important',
        fontWeight: 510,
    },
    arrow: {
        color: "#fff",
        boxShadow: '0 1rem 3rem rgba(0, 0, 0, .175) !important',
    },
})(Tooltip);

export const LightToolTip = withStyles({
    tooltip: {
        color: "#030D1F",
        backgroundColor: "#ffffff",
        padding: '10px',
        boxShadow: '0 1rem 3rem rgba(0, 0, 0, .175) !important',
        marginTop: '5px !important'
    },
})(Tooltip);    